import { Button, Modal } from "react-bootstrap";
import { ACTION_TYPE, REPORT_NAME } from "../../constant/reportType";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { alertMessage } from "../../utils/AlertService";
import { useEffect, useState } from "react";
import Loading from "../Loading";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useGetAllCountryMutation } from "../../redux-toolkit/services/countryService";
import { useGetStateMutation } from "../../redux-toolkit/services/stateService";
import { getAllcountryDetail, setcountry } from "../../redux-toolkit/slices/countrySlice";
import { getFindStateByCountryNameDetail, setStates } from "../../redux-toolkit/slices/statesSlice";
import { useGetUserByIdMutation, useSaveUserMutation, useUpdateUserMutation } from "../../redux-toolkit/services/allUserService";
import { useGetAllUserRoleMutation, useGetUserRoleByIdMutation, useSaveUserRoleMutation, useUpdateUserRoleMutation } from "../../redux-toolkit/services/userRoleService";
import { useGetAllUserGroupMutation, useGetUserGroupByIdMutation, useSaveUserGroupMutation, useUpdateUserGroupMutation } from "../../redux-toolkit/services/userGroupService";
import { getAllUserRoleDetails, setAllUserRole } from "../../redux-toolkit/slices/allUserRoleSlice";
import { getAllUserGroupDetails, setAllUserGroup } from "../../redux-toolkit/slices/allUserGroupSlice";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { useGetAllPackagesMutation, useGetPackageByIdMutation, useSavePackageMutation, useUpdatePackageByIdMutation } from "../../redux-toolkit/services/packageMasterService";
import { getPackageMasterList, setAllPackageMasterList } from "../../redux-toolkit/slices/packageMasterSlice";
import { useAppSelector } from "../../redux-toolkit/hooks";

type Props = {
    show: boolean;
    setShow: any;
    actionType: ACTION_TYPE;
    reportName: string;
    data: any;
    setCall: any;
};



const UserMasterReportData = (props: Props) => {

    const localUserObj: any = getLocalStorageData("localUser");
    const dispatch = useDispatch();

    //states
    const [getByIdData, setGetByIdData]: any = useState([]);
    const [selectedCountry, setSelectedCountry]: any = useState();

    //save
    const [saveUser, saveUserResponse] = useSaveUserMutation();
    const [saveUserRole, saveUserRoleResponse] = useSaveUserRoleMutation();
    const [saveUserGroup, saveUserGroupResponse] = useSaveUserGroupMutation();
    const [savePackage, savePackageResponse] = useSavePackageMutation();

    //update
    const [updateUser, updateUserResponse] = useUpdateUserMutation();
    const [updateUserRole, updateUserRoleResponse] = useUpdateUserRoleMutation();
    const [updateUserGroup, updateUserGroupResponse] = useUpdateUserGroupMutation();
    const [updatePackage, updatePackageResponse] = useUpdatePackageByIdMutation();

    //getById mutation
    const [getUserById, userByIdResponse]: any = useGetUserByIdMutation();
    const [getAllUserRole, getAllUserRoleResponse] = useGetAllUserRoleMutation();
    const [getAllUserGroup, getAllUserGroupResponse] = useGetAllUserGroupMutation();
    const [getUserRoleById, userRoleByIdResponse]: any = useGetUserRoleByIdMutation();
    const [getUserGroupById, userGroupByIdResponse]: any = useGetUserGroupByIdMutation();
    const [getPackageById, getPackageByIdResponse] = useGetPackageByIdMutation();

    // get All Mutation
    const [getAllPackages, getAllPackagesResponse] = useGetAllPackagesMutation();


    //getData
    const [getCountry, getCountryResponse] = useGetAllCountryMutation();
    const [getState, getStateResponse] = useGetStateMutation();

    //Data
    const allCountries: any = useAppSelector(getAllcountryDetail);
    const allStates: any = useAppSelector(getFindStateByCountryNameDetail);
    const allUserRole: any = useAppSelector(getAllUserRoleDetails);
    const allUserGroup: any = useAppSelector(getAllUserGroupDetails);
    const getAllPackagesList: any = useAppSelector(getPackageMasterList)

    const UserSchema = Yup.object().shape({
        firstName: Yup.string().required("Please enter First name!"),
        lastName: Yup.string().required("Please enter Last name!"),
        // briefProfile: Yup.string()
        //     .required("Please enter Description!")
        //     .min(10, "Description is Too Short!")
        //     .max(100, "Description Too Long!"),
        phoneNumber: Yup.string()
            .required("Please enter phone Number!")
            .matches(
                /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/,
                "Phone number is not valid"
            )
            .min(10, "Contact Number must be 10 digits")
            .max(10, "Contact Number must be 10 digits")
            .trim(),

        email: Yup.string()
            .email("Invalid email format")
            .required("Please enter Email Address!"),

        selectedPackage: Yup.string().when("role", (role, schema) => {
            const roleId = Array.isArray(role) ? role[0] : role;
            const roleObj = allUserRole?.find((r: any) => r.id == roleId);
            const isAdmin = roleObj?.name === "Admin";
            return isAdmin
                ? schema.notRequired()
                : schema.required("Please select package to proceed!");
        }),
        group: Yup.string().required("Please select group"),
        role: Yup.string().required("Please select role"),

        termsAndConditionsCheckbox: Yup.boolean()
            .oneOf([true], "Please agree to the Terms and Conditions")
            .required(),

        privacyPolicyCheckbox: Yup.boolean()
            .oneOf([true], "Please agree to the Privacy Policy")
            .required(),
        pricingType: Yup.string().when("role", (role, schema) => {
            const roleId = Array.isArray(role) ? role[0] : role;
            const roleObj = allUserRole?.find((r: any) => r.id == roleId);
            const isAdmin = roleObj?.name === "Admin";
            return isAdmin
                ? schema.notRequired()
                : schema.required("Please select pricing type!");
        }),

    });

    const UserPackageSchema = Yup.object().shape({
        packageName: Yup.string().required("Please enter Package Name!"),
        packageDescription: Yup.string().required("Please enter Package Description!"),
        pricingPerMonth: Yup.number()
            .typeError("Please enter a valid number")
            .required("Please enter Pricing per Month!"),
        pricingPerYear: Yup.number()
            .typeError("Please enter a valid number")
            .required("Please enter Pricing per Year!"),
        defaultCurrency: Yup.string().required("Please enter Default Currency!"),
    });

    const pricingTypes = [
        { label: "Monthly", value: "monthly" },
        { label: "Yearly", value: "yearly" }
    ];



    useEffect(() => {
        if (getAllPackagesResponse.isSuccess) {
            dispatch(setAllPackageMasterList(getAllPackagesResponse));
        }
        else if (getAllPackagesResponse.isError) {
            alertMessage("Error while fetching packages", "error");
        }

    }, [getAllPackagesResponse.isSuccess, getAllPackagesResponse.isError]);

    useEffect(() => {
        if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.USER_MASTER) {
                // getAllOrganizations({ token: localUserObj.token })
                getUserById({
                    id: props?.data?.id,
                    token: localUserObj?.token
                })
                getCountry({});
                getAllUserGroup({ token: localUserObj.token });
                getAllUserRole({ token: localUserObj.token });
                getAllPackages({ token: localUserObj?.token });
            } else if (props.reportName == REPORT_NAME.USER_ROLE) {
                getUserRoleById({
                    token: localUserObj.token,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.USER_PACKAGE) {
                getPackageById({
                    token: localUserObj.token,
                    id: props?.data?.id,
                });
            }
            else if (props.reportName === REPORT_NAME.USER_PACKAGE) {
                getUserGroupById({
                    token: localUserObj.token,
                    id: props?.data?.id,
                });
            }
        } else if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            if (props.reportName === REPORT_NAME.USER_MASTER) {
                getCountry({});
                getAllUserGroup({ token: localUserObj.token });
                getAllUserRole({ token: localUserObj.token });
                getAllPackages({ token: localUserObj?.token });
            }
        }

    }, [props.reportName]);

    const handleClose = () => {
        props.setShow(false);
    };

    const handleSubmit = (values: any) => {

        if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            if (props.reportName === REPORT_NAME.USER_MASTER) {
                const payload = {
                    address: values.address,
                    // briefProfile: values.briefProfile,
                    cityId: values.city,
                    countryId: parseInt(selectedCountry),
                    email: values.email,
                    firstName: values.firstName,
                    lastName: values.lastName,
                    linkedinRef: values.linkedinRef,
                    organizationName: values.organizationName,
                    organizationId: values.organizationId,
                    password: values.email,
                    phoneNumber: values.phoneNumber,
                    postalCode: values.pinCode,
                    stateId: parseInt(values.state),
                    userGroupId: parseInt(values.group),
                    userRoleId: parseInt(values.role),
                    roleIds: [parseInt(values.role)],
                    username: values.email,
                    termsAndCondition: values.termsAndConditionsCheckbox,
                    privacyPolicy: values.privacyPolicyCheckbox,
                    packageId: parseInt(values.selectedPackage),
                    isUserSubscribed: true,
                    packageType: values.pricingType
                }
                saveUser({
                    token: localUserObj?.token,
                    payload: payload
                });
            } else if (props.reportName === REPORT_NAME.USER_ROLE) {
                saveUserRole({
                    token: localUserObj.token,
                    payload: {
                        status: true,
                        name: values.name,
                        userGroupId: 1,
                    },
                });
            } else if (props.reportName === REPORT_NAME.USER_GROUP) {
                saveUserGroup({
                    token: localUserObj.token,
                    payload: {
                        status: true,
                        name: values.name,
                    },
                });
            }
            else if (props.reportName === REPORT_NAME.USER_PACKAGE) {
                savePackage({
                    token: localUserObj.token,
                    payload: {
                        status: true,
                        name: values.packageName,
                        packageDescription: values.packageDescription,
                        defaultCurrency: values.defaultCurrency,
                        pricingPerMonth: values.pricingPerMonth,
                        pricingPerYear: values.pricingPerYear,
                    },
                });
            }
        } else if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.USER_MASTER) {
                const payload = {
                    id: props?.data?.id,
                    status: props.data.enabled,
                    address: values.address,
                    // briefProfile: values.briefProfile,
                    cityId: values.city,
                    countryId: parseInt(selectedCountry),
                    email: values.email,
                    firstName: values.firstName,
                    lastName: values.lastName,
                    linkedinRef: values.linkedinRef,
                    // organizationName: orgObj.name,
                    organizationId: values.organizationId,
                    password: values.email,
                    phoneNumber: values.phoneNumber,
                    postalCode: values.pinCode,
                    stateId: parseInt(values.state),
                    userGroupId: parseInt(values.group),
                    userRoleId: parseInt(values.role),
                    roleIds: [parseInt(values.role)],
                    username: values.email,
                    termsAndCondition: values.termsAndConditionsCheckbox,
                    privacyPolicy: values.privacyPolicyCheckbox,
                    packageId: parseInt(values.selectedPackage),
                    isUserSubscribed: true,
                    packageType: values.pricingType
                }

                updateUser({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                    payload: payload
                })

            } else if (props.reportName === REPORT_NAME.USER_ROLE) {
                updateUserRole({
                    token: localUserObj.token,
                    // id: props?.data?.id,
                    payload: {
                        status: props.data.status,
                        id: props?.data?.id,
                        name: values.name,
                    },
                });
            } else if (props.reportName === REPORT_NAME.USER_GROUP) {
                updateUserGroup({
                    token: localUserObj.token,
                    id: props?.data?.id,
                    payload: {
                        status: props.data.status,
                        id: props?.data?.id,
                        name: values.name,
                    },
                });
            }
            else if (props.reportName === REPORT_NAME.USER_PACKAGE) {
                updatePackage({
                    token: localUserObj.token,
                    id: props?.data?.id,
                    payload: {
                        status: props.data.status,
                        id: props?.data?.id,
                        name: values.packageName,
                        packageDescription: values.packageDescription,
                        defaultCurrency: values.defaultCurrency,
                        pricingPerMonth: values.pricingPerMonth,
                        pricingPerYear: values.pricingPerYear,
                    },
                });
            }
        }
    };


    const handleSelectCountry = (event: any) => {
        setSelectedCountry(event.target.value);
        if (event) {
            getState({
                countryId: event.target.value,
            });
        }
    };

    useEffect(() => {
        if (getCountryResponse.isSuccess) {
            dispatch(setcountry(getCountryResponse));
        } else if (getCountryResponse.isError) {
            alertMessage("Error while fetching countries", "error");
        }
    }, [getCountryResponse.isSuccess, getCountryResponse.isError]);

    useEffect(() => {
        if (getStateResponse.isSuccess) {
            dispatch(setStates(getStateResponse));
        } else if (getStateResponse.isError) {
            alertMessage("Error while fetchin states", "error");
        }
    }, [getStateResponse.isSuccess, getStateResponse.isError]);

    useEffect(() => {
        if (getAllUserRoleResponse.isSuccess) {
            dispatch(setAllUserRole(getAllUserRoleResponse));
        } else if (getAllUserRoleResponse.isError) {
            let response: any = getAllUserRoleResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllUserRoleResponse.isSuccess, getAllUserRoleResponse.isError]);

    useEffect(() => {
        if (getAllUserGroupResponse.isSuccess) {
            dispatch(setAllUserGroup(getAllUserGroupResponse));
        } else if (getAllUserGroupResponse.isError) {
            let response: any = getAllUserGroupResponse.error;
            alertMessage(response, "error");
        }
    }, [getAllUserGroupResponse.isSuccess, getAllUserGroupResponse.isError]);

    useEffect(() => {
        if (userByIdResponse.isSuccess) {
            setGetByIdData(userByIdResponse.data);
            setSelectedCountry(parseInt(userByIdResponse.data.countryId))
            getState({ countryId: userByIdResponse.data.countryId });

        } else if (userByIdResponse.isError) {
            alertMessage("Error while getting user data", "error");
        }
    }, [userByIdResponse.isSuccess, userByIdResponse.isError]);


    useEffect(() => {
        if (getPackageByIdResponse.isSuccess) {
            setGetByIdData(getPackageByIdResponse.data);
        } else if (getPackageByIdResponse.isError)
            alertMessage("Error while getting user data", "error");
    }, [getPackageByIdResponse.isSuccess, getPackageByIdResponse.isError])

    useEffect(() => {
        if (userRoleByIdResponse.isSuccess) {
            setGetByIdData(userRoleByIdResponse.data);
        } else if (userRoleByIdResponse.isError) {
            let response: any = userRoleByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [userRoleByIdResponse.isSuccess, userRoleByIdResponse.isError]);

    useEffect(() => {
        if (userGroupByIdResponse.isSuccess) {
            setGetByIdData(userGroupByIdResponse.data);
        } else if (userGroupByIdResponse.isError) {
            let response: any = userGroupByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [userGroupByIdResponse.isSuccess, userGroupByIdResponse.isError]);

    useEffect(() => {
        if (saveUserResponse.isSuccess) {
            alertMessage("User added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveUserResponse.isError) {
            let response: any = saveUserResponse?.error;
            let msg: any = response.data?.serviceErrors[0]?.msg;
            alertMessage(msg, "error");
        }
    }, [saveUserResponse.isSuccess, saveUserResponse.isError]);

    useEffect(() => {
        if (updateUserResponse.isSuccess) {
            alertMessage("User updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateUserResponse.isError) {
            let response: any = updateUserResponse?.error;
            let msg: any = response.data?.serviceErrors[0]?.msg;
            alertMessage(msg, "error");
        }
    }, [updateUserResponse.isSuccess, updateUserResponse.isError]);

    useEffect(() => {
        if (saveUserRoleResponse.isSuccess) {
            alertMessage("User role added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveUserRoleResponse.isError) {
            let response: any = saveUserRoleResponse?.error;
            let msg: any = response.data?.serviceErrors[0]?.msg;
            alertMessage(msg, "error");
        }
    }, [saveUserRoleResponse.isSuccess, saveUserRoleResponse.isError]);

    useEffect(() => {
        if (updateUserRoleResponse.isSuccess) {
            alertMessage("User role updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateUserRoleResponse.isError) {
            let response: any = updateUserRoleResponse?.error;
            let msg: any = response.data?.serviceErrors[0]?.msg;
            alertMessage(msg, "error");
        }
    }, [updateUserRoleResponse.isSuccess, updateUserRoleResponse.isError]);

    //user group
    useEffect(() => {
        if (saveUserGroupResponse.isSuccess) {
            alertMessage("User group added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveUserGroupResponse.isError) {
            let response: any = saveUserGroupResponse?.error;
            let msg: any = response.data?.serviceErrors[0]?.msg;
            alertMessage(msg, "error");
        }
    }, [saveUserGroupResponse.isSuccess, saveUserGroupResponse.isError]);



    useEffect(() => {
        if (savePackageResponse.isSuccess) {
            alertMessage("package added successfully", "success");
            props.setCall("Y");
            handleClose();
        }
        else if (saveUserGroupResponse.isError) {
            let response: any = savePackageResponse?.error;
            let msg: any = response.data?.serviceErrors[0]?.msg;
            alertMessage(msg, "error");
        }
    }, [savePackageResponse.isSuccess, savePackageResponse.isError])

    useEffect(() => {
        if (updateUserGroupResponse.isSuccess) {
            alertMessage("User group updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateUserGroupResponse.isError) {
            let response: any = updateUserGroupResponse?.error;
            let msg: any = response?.error ? response.error.data.error : "Error while updating";
            alertMessage(msg, "error");
        }
    }, [updateUserGroupResponse.isSuccess, updateUserGroupResponse.isError]);


    useEffect(() => {
        if (updatePackageResponse.isSuccess) {
            alertMessage("Package updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updatePackageResponse.isError) {
            let response: any = updatePackageResponse?.error;
            let msg: any = response?.error ? response.error.data.error : "Error while updating";
            alertMessage(msg, "error");
        }

    }, [updatePackageResponse.isSuccess, updatePackageResponse.isError]);

    return (
        <>
            <Modal
                show={props.show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                // dialogClassName={"modal-90w"}
                {...((props.reportName === REPORT_NAME.USER_ROLE || props.reportName === REPORT_NAME.USER_GROUP)
                    ? { dialogClassName: "modal-90w" }
                    : { size: "lg" })}
            >
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold text-primary" style={{ fontSize: "1rem" }}>
                        {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"}{" "}
                        {props.reportName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {saveUserResponse.isLoading ||
                        updateUserResponse.isLoading ||
                        userByIdResponse.isLoading ||
                        getCountryResponse.isLoading ||
                        getStateResponse.isLoading ? (
                        <Loading />
                    ) : (
                        ""
                    )}
                    <Formik
                        validationSchema={
                            props.reportName === REPORT_NAME.USER_MASTER
                                ? UserSchema
                                : props.reportName === REPORT_NAME.USER_PACKAGE
                                    ? UserPackageSchema
                                    : undefined
                        }
                        enableReinitialize={true}
                        initialValues={
                            props.reportName === REPORT_NAME.USER_MASTER
                                ? {
                                    firstName:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.firstName || ""
                                            : "",
                                    lastName:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.lastName || ""
                                            : "",
                                    email:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.email || ""
                                            : "",
                                    phoneNumber:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.phoneNumber || ""
                                            : "",
                                    linkedinRef:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.name || ""
                                            : "",
                                    group:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.userGroup?.id || ""
                                            : "",
                                    role:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.userRole?.id || ""
                                            : "",
                                    address:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.address || ""
                                            : "",
                                    state:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.stateId || ""
                                            : "",
                                    city:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.city || ""
                                            : "",
                                    country:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.countryId || ""
                                            : "",
                                    selectedPackage:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.packageId || ""
                                            : "",
                                    pricingType: props.actionType === ACTION_TYPE.UPDATE_ACTION
                                        ? getByIdData?.packageType || ""
                                        : "",
                                    pinCode:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.postalCode || ""
                                            : "",
                                    // briefProfile:
                                    //     props.actionType === ACTION_TYPE.UPDATE_ACTION
                                    //         ? getByIdData?.name || ""
                                    //         : "",
                                    termsAndConditionsCheckbox:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? !!getByIdData?.termsAndCondition
                                            : true,
                                    privacyPolicyCheckbox:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? !!getByIdData?.privacyPolicy
                                            : true,
                                }
                                : props.reportName === REPORT_NAME.USER_PACKAGE
                                    ? {
                                        packageName:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData?.name || ""
                                                : "",
                                        packageDescription:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData?.packageDescription || ""
                                                : "",
                                        pricingPerMonth:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData?.pricingPerMonth || ""
                                                : "",
                                        pricingPerYear: props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData?.pricingPerYear || ""
                                            : "",
                                        defaultCurrency:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData?.defaultCurrency || ""
                                                : "",
                                    }
                                    : {
                                        name:
                                            props.actionType === ACTION_TYPE.UPDATE_ACTION
                                                ? getByIdData?.name || ""
                                                : "",
                                    }
                        }

                        onSubmit={handleSubmit}
                    >
                        {({ values, handleChange, setFieldValue, errors, touched, handleBlur }) => (
                            <Form>
                                {(props.reportName === REPORT_NAME.USER_MASTER) ? (
                                    <div>
                                        <div className="d-flex justify-content-center">
                                            <div className="col-lg-6">
                                                <div className="mb-3">
                                                    <input
                                                        type="text"
                                                        value={values.firstName}
                                                        name="firstName"
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        className={`form-control form-textbox bg-secondary-light border-secondary-light ${errors.firstName ? 'is-invalid' : ''}`}
                                                        id="firstName"
                                                        aria-describedby="firstName"
                                                        placeholder="First Name"
                                                    />
                                                    {touched.firstName && typeof errors.firstName === 'string' && (
                                                        <div className="text-danger">{errors.firstName}</div>
                                                    )}
                                                </div>
                                                <div className="mb-3">
                                                    <input
                                                        type="email"
                                                        value={values.email}
                                                        name="email"
                                                        onChange={handleChange}
                                                        className={`form-control form-textbox bg-secondary-light border-secondary-light ${errors.email ? 'is-invalid' : ''}`}
                                                        id="email"
                                                        aria-describedby="email"
                                                        placeholder="Email"
                                                    />
                                                    {touched.email && typeof errors.email === 'string' && (
                                                        <div className="text-danger">{errors.email}</div>
                                                    )}
                                                </div>
                                                <div className="mb-3">

                                                </div>
                                                <div className="mb-3">
                                                    <select
                                                        className={`form-select form-textbox ${errors.group ? 'is-invalid' : ''}`}
                                                        aria-label="selectColumn"
                                                        onChange={handleChange}
                                                        aria-placeholder="Group"
                                                        value={values.group}
                                                        name="group"
                                                    >
                                                        <option>Group</option>
                                                        {allUserGroup && allUserGroup.map((userGroup: any, index: any) => {
                                                            return (
                                                                <option key={index} value={userGroup.id}>
                                                                    {userGroup.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                    {touched.group && typeof errors.group === 'string' && (
                                                        <div className="text-danger">{errors.group}</div>
                                                    )}
                                                </div>
                                                <div className="mb-3">
                                                    <input
                                                        type="text"
                                                        value={values.address}
                                                        name="address"
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                            // setOrgName(e.target.value)
                                                        }}
                                                        className={`form-control form-textbox bg-secondary-light border-secondary-light ${errors.address ? 'is-invalid' : ''}`}
                                                        id="address"
                                                        aria-describedby="address"
                                                        placeholder="Address"
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <select
                                                        className="form-select form-textbox"
                                                        // ${errors.country ? 'is-invalid' : ''}
                                                        aria-label="selectColumn"
                                                        onChange={handleSelectCountry}
                                                        aria-placeholder="Country"
                                                        name="country"
                                                        value={selectedCountry}
                                                    >
                                                        <option>Country</option>
                                                        {allCountries && allCountries.map((country: any, index: any) => {
                                                            return (
                                                                <option key={index} value={country.id}>
                                                                    {country.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                                <div className="mb-3">
                                                    <select
                                                        className="form-select form-textbox bg-secondary-light border-secondary-light"
                                                        // ${errors.state ? 'is-invalid' : ''}
                                                        aria-label="selectColumn"
                                                        onChange={handleChange}
                                                        aria-placeholder="State"
                                                        name="state"
                                                        value={values.state}
                                                    >
                                                        <option>State</option>
                                                        {allStates && allStates.map((state: any, index: any) => {
                                                            return (
                                                                <option key={index} value={state.id}>
                                                                    {state.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                                {(() => {
                                                    const selectedRoleId = Array.isArray(values.role) ? values.role[0] : values.role;
                                                    const selectedRole = allUserRole?.find((role: any) => role.id == selectedRoleId);

                                                    if (selectedRole?.name === "Admin") return null;

                                                    return (
                                                        <div className="mb-3">
                                                            <select
                                                                className={`form-select form-textbox ${errors.selectedPackage ? 'is-invalid' : ''}`}
                                                                aria-label="selectColumn"
                                                                onChange={handleChange}
                                                                name="selectedPackage"
                                                                value={values.selectedPackage}
                                                            >
                                                                <option value="">Pricing Plan</option>
                                                                {getAllPackagesList && getAllPackagesList.map((selectedPackage: any, index: any) => (
                                                                    <option key={index} value={selectedPackage.id}>
                                                                        {selectedPackage.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {touched.selectedPackage && typeof errors.selectedPackage === 'string' && (
                                                                <div className="text-danger">{errors.selectedPackage}</div>
                                                            )}
                                                        </div>
                                                    );
                                                })()}
                                            </div>
                                            <div className="col-lg-6 ms-3">
                                                <div className="mb-3">
                                                    <input
                                                        type="text"
                                                        value={values.lastName}
                                                        name="lastName"
                                                        onChange={handleChange}
                                                        className={`form-control form-textbox bg-secondary-light border-secondary-light ${errors.lastName ? 'is-invalid' : ''}`}
                                                        id="lastName"
                                                        aria-describedby="lastName"
                                                        placeholder="Last Name"
                                                    />
                                                    {touched.lastName && typeof errors.lastName === 'string' && (
                                                        <div className="text-danger">{errors.lastName}</div>
                                                    )}
                                                </div>
                                                <div className="mb-3">
                                                    <input
                                                        type="number"
                                                        value={values.phoneNumber}
                                                        name="phoneNumber"
                                                        onChange={handleChange}
                                                        className={`form-control form-textbox bg-secondary-light border-secondary-light ${errors.phoneNumber ? 'is-invalid' : ''}`}
                                                        id="phoneNumber"
                                                        aria-describedby="phoneNumber"
                                                        placeholder="Mobile Number"
                                                    />
                                                    {touched.phoneNumber && typeof errors.phoneNumber === 'string' && (
                                                        <div className="text-danger">{errors.phoneNumber}</div>
                                                    )}
                                                </div>
                                                <div className="mb-3">
                                                    <input
                                                        type="text"
                                                        value={values.linkedinRef}
                                                        name="linkedinRef"
                                                        onChange={handleChange}
                                                        className={`form-control form-textbox bg-secondary-light border-secondary-light ${errors.linkedinRef ? 'is-invalid' : ''}`}
                                                        id="linkedinRef"
                                                        aria-describedby="linkedinRef"
                                                        placeholder="Linkedin Ref"
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <select
                                                        className={`form-select form-textbox ${errors.role ? 'is-invalid' : ''}`}
                                                        aria-label="selectColumn"
                                                        onChange={handleChange}
                                                        aria-placeholder="Role"
                                                        value={values.role}
                                                        name="role"
                                                    >
                                                        <option>Role</option>
                                                        {allUserRole && allUserRole.map((role: any, index: any) => {
                                                            return (
                                                                <option key={index} value={role.id}>
                                                                    {role.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                    {touched.role && typeof errors.role === 'string' && (
                                                        <div className="text-danger">{errors.role}</div>
                                                    )}
                                                </div>
                                                <div className="mb-3">
                                                    <input
                                                        className="form-control form-textbox"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.city}
                                                        name="city"
                                                        placeholder="City"
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <input
                                                        type="text"
                                                        value={values.pinCode}
                                                        name="pinCode"
                                                        onChange={handleChange}
                                                        className={`form-control form-textbox bg-secondary-light border-secondary-light ${errors.pinCode ? 'is-invalid' : ''}`}
                                                        id="pinCode"
                                                        aria-describedby="pinCode"
                                                        placeholder="Remark"
                                                    />
                                                </div>
                                                {(() => {
                                                    const selectedRoleId = Array.isArray(values.role) ? values.role[0] : values.role;
                                                    const selectedRole = allUserRole?.find((role: any) => role.id == selectedRoleId);

                                                    if (selectedRole?.name === "Admin") return null;

                                                    return (
                                                        <div className="mb-3">
                                                            <select
                                                                className={`form-select form-textbox ${errors.pricingType ? 'is-invalid' : ''}`}
                                                                aria-label="selectPricingType"
                                                                onChange={handleChange}
                                                                name="pricingType"
                                                                value={values.pricingType}
                                                            >
                                                                <option value="">Pricing Type</option>
                                                                {pricingTypes.map((type, index) => (
                                                                    <option key={index} value={type.value}>
                                                                        {type.label}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {touched.pricingType && typeof errors.pricingType === 'string' && (
                                                                <div className="text-danger">{errors.pricingType}</div>
                                                            )}
                                                        </div>
                                                    );
                                                })()}
                                            </div>
                                        </div>
                                        <div className="d-flex flex-column">
                                            {/* Terms and Conditions */}
                                            <div className="form-check mb-2">
                                                <input
                                                    type="checkbox"
                                                    id="termsAndConditionsCheckbox"
                                                    name="termsAndConditionsCheckbox"
                                                    checked={values.termsAndConditionsCheckbox}
                                                    onChange={handleChange}
                                                    className={`form-check-input ${errors.termsAndConditionsCheckbox && touched.termsAndConditionsCheckbox ? 'is-invalid' : ''}`}
                                                />
                                                <label htmlFor="termsAndConditionsCheckbox" className="ms-1 text-secondary">
                                                    I agree to the{" "}
                                                    <Link
                                                        to=""
                                                        // onClick={() => localStorage.setItem("routeTo", "terms-and-conditions")}
                                                        target="_blank"
                                                        className="text-primary"
                                                    >
                                                        Terms and Conditions.
                                                    </Link>
                                                </label>
                                                {errors.termsAndConditionsCheckbox && touched.termsAndConditionsCheckbox && (
                                                    <div className="text-danger">{errors.termsAndConditionsCheckbox}</div>
                                                )}
                                            </div>

                                            {/* Privacy Policy */}
                                            <div className="form-check mb-2">
                                                <input
                                                    type="checkbox"
                                                    id="privacyPolicyCheckbox"
                                                    name="privacyPolicyCheckbox"
                                                    checked={values.privacyPolicyCheckbox}
                                                    onChange={handleChange}
                                                    className={`form-check-input ${errors.privacyPolicyCheckbox && touched.privacyPolicyCheckbox ? 'is-invalid' : ''}`}
                                                />
                                                <label htmlFor="privacyPolicyCheckbox" className="ms-1 text-secondary">
                                                    I have read and agree to the{" "}
                                                    <Link
                                                        to=""
                                                        // onClick={() => localStorage.setItem("routeTo", "privacy-policy")}
                                                        target="_blank"
                                                        className="text-primary"
                                                    >
                                                        Privacy Policy.
                                                    </Link>
                                                </label>
                                                {errors.privacyPolicyCheckbox && touched.privacyPolicyCheckbox && (
                                                    <div className="text-danger">{errors.privacyPolicyCheckbox}</div>
                                                )}
                                            </div>
                                        </div>

                                    </div>
                                ) :
                                    (props.reportName === REPORT_NAME.USER_PACKAGE) ? (
                                        <>
                                            <div className="mb-2">
                                                <label className="form-label">
                                                    Package Name <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    className={`form-control form-control-sm ${touched.packageName && errors.packageName ? "is-invalid" : ""
                                                        }`}
                                                    type="text"
                                                    name="packageName"
                                                    value={values.packageName}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                {touched.packageName && typeof errors.packageName === "string" && (
                                                    <div className="invalid-feedback d-block">{errors.packageName}</div>
                                                )}
                                            </div>

                                            <div className="mb-2">
                                                <label className="form-label">
                                                    Package Description <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    className={`form-control form-control-sm ${touched.packageDescription && errors.packageDescription ? "is-invalid" : ""
                                                        }`}
                                                    type="text"
                                                    name="packageDescription"
                                                    value={values.packageDescription}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                {touched.packageDescription && typeof errors.packageDescription === "string" && (
                                                    <div className="invalid-feedback d-block">{errors.packageDescription}</div>
                                                )}
                                            </div>

                                            <div className="mb-2">
                                                <label className="form-label">
                                                    Pricing per Month <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    className={`form-control form-control-sm ${touched.pricingPerMonth && errors.pricingPerMonth ? "is-invalid" : ""
                                                        }`}
                                                    type="text"
                                                    name="pricingPerMonth"
                                                    value={values.pricingPerMonth}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                {touched.pricingPerMonth && typeof errors.pricingPerMonth === "string" && (
                                                    <div className="invalid-feedback d-block">{errors.pricingPerMonth}</div>
                                                )}
                                            </div>

                                            <div className="mb-2">
                                                <label className="form-label">
                                                    Pricing per Year <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    className={`form-control form-control-sm ${touched.pricingPerYear && errors.pricingPerYear ? "is-invalid" : ""
                                                        }`}
                                                    type="text"
                                                    name="pricingPerYear"
                                                    value={values.pricingPerYear}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                {touched.pricingPerYear && typeof errors.pricingPerYear === "string" && (
                                                    <div className="invalid-feedback d-block">{errors.pricingPerYear}</div>
                                                )}
                                            </div>

                                            <div className="mb-2">
                                                <label className="form-label">
                                                    Default Currency <span style={{ color: "red" }}>*</span>
                                                </label>
                                                <input
                                                    className={`form-control form-control-sm ${touched.defaultCurrency && errors.defaultCurrency ? "is-invalid" : ""
                                                        }`}
                                                    type="text"
                                                    name="defaultCurrency"
                                                    value={values.defaultCurrency}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                />
                                                {touched.defaultCurrency && typeof errors.defaultCurrency === "string" && (
                                                    <div className="invalid-feedback d-block">{errors.defaultCurrency}</div>
                                                )}
                                            </div>
                                        </>
                                    ) : (
                                        <div>
                                            <div className="d-flex">
                                                <div> {props.reportName} Name</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                            <input
                                                className="form-control form-control-sm w-100"
                                                type="text"
                                                aria-label=".form-control-sm example"
                                                onChange={handleChange}
                                                value={values.name}
                                                name="name"
                                                required
                                            />
                                        </div>
                                    )}
                                <div className="d-flex flex-row justify-content-center">
                                    <button
                                        type="submit"
                                        className={`btn btn-primary btn-block mt-3 mx-2 btn-width`}
                                    >
                                        {props.actionType === ACTION_TYPE.ADD_ACTION
                                            ? "Save"
                                            : "Update"}
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-block mt-3 mx-2 btn-width"
                                        onClick={handleClose}
                                    >
                                        Close
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal >
        </>
    );

};

export default UserMasterReportData